import { ReactComponentElement } from 'react';
import { observer } from 'mobx-react';

import FancyPopup from '@/common/components/FancyPopup/FancyPopup';
import Link, { NONE } from '@/common/components/Link/Link';
import { getPricingUrl } from '@/common/helpers/getPricingUrl';

import MenuItem from '../../MenuList/MenuItem/MenuItem';
import MenuList from '../../MenuList/MenuList';
import headerStyles from '../Header.module.css';

export interface AboutPopoverProps {
  isOpened: boolean;
  close: () => void;
  onChangeState: (isOpened: boolean) => void;
  onCollectionsClick: () => void;
  onPresentationClick: () => void;
  onWorkshopClick: () => void;
  onPricingClick: () => void;
  onPrivacyPolicyClick: () => void;
  children: ReactComponentElement<Any>;
}

function AboutPopover(props: AboutPopoverProps) {
  const {
    children,
    isOpened,
    close,
    onChangeState,
    onCollectionsClick,
    onPresentationClick,
    onPricingClick,
    onWorkshopClick,
    onPrivacyPolicyClick,
  } = props;

  return (
    <FancyPopup
      action="click"
      isOpen={isOpened}
      onChangeState={onChangeState}
      onClickOutside={close}
      placement="bottom"
      usePortal
      isPlain
      trigger={children}
      body={(
        <MenuList withRoundedCorners>
          <MenuItem className={headerStyles.showOnSmallScreens}>
            <Link aria-label="Demo" activeClassName="active" appearance={NONE} exact onClick={onCollectionsClick} to="/collections">
              Demo
            </Link>
          </MenuItem>

          <MenuItem>
            <Link aria-label="Technology Overview" appearance={NONE} external href="/pr/#/" onClick={onPresentationClick}>
              Technology Overview
            </Link>
          </MenuItem>

          <MenuItem>
            <Link aria-label="What's new" appearance={NONE} external href="https://octonus-teams.com/wiki/display/CUDO/Release+Notes">
              What&apos;s new
            </Link>
          </MenuItem>

          <MenuItem>
            <Link aria-label="Embed Cutwise Widget" appearance={NONE} external href="https://octonus-teams.com/wiki/display/CUDO/Cutwise+Widget">
              Embed Cutwise Widget
            </Link>
          </MenuItem>

          <MenuItem>
            <Link aria-label="API Documentation" appearance={NONE} external href="https://api-doc.cutwise.com/">
              API Documentation
            </Link>
          </MenuItem>

          <MenuItem>
            <Link aria-label="YouTube Channel" appearance={NONE} external href="https://www.youtube.com/channel/UCgIrQJ25wIuLfCPbFcZ4S6Q">
              YouTube Channel
            </Link>
          </MenuItem>

          <MenuItem>
            <Link
              aria-label="Performance Workshop"
              appearance={NONE}
              external
              href="https://docs.cutwise.com/knowledge-base/performance-workshop"
              onClick={onWorkshopClick}
            >
              Performance Workshop
            </Link>
          </MenuItem>

          <MenuItem>
            <Link aria-label="Pricing" appearance={NONE} external href={getPricingUrl()} onClick={onPricingClick}>
              Pricing
            </Link>
          </MenuItem>

          <MenuItem>
            <Link aria-label="Privacy Policy" appearance={NONE} external href="/privacy" onClick={onPrivacyPolicyClick}>
              Privacy Policy
            </Link>
          </MenuItem>

          <MenuItem>
            <Link aria-label="Contacts" appearance={NONE} external href="/about">
              Contacts
            </Link>
          </MenuItem>
        </MenuList>
      )}
    />
  );
}

export default observer(AboutPopover);
